




































import { Component } from 'vue-property-decorator';

import { Gradient } from '@/components/wobble/model';
import Chapter from './Chapter.vue';
import FloatingWobble from '@/components/wobble/FloatingWobble.vue';

@Component({
  components: {
    FloatingWobble,
  }
})
export default class EndScreen extends Chapter {
  public wobbleGradient = new Gradient(
    '#AF7BEB',
    '#21D1AC',
    0.0,
    0.72,
    76.02,
    236.6,
    448.83,
    255.5,
  );
}
